import request, { buildFormDataObject, formatRequestBody } from 'utils/request';

// Constants
import {
  GET_MERCHANT_DOCS_URL,
  GET_MERCHANT_DOC_URL,
  GET_REG_DETAILS_URL,
  GET_SELECTED_REG_DETAILS_URL,
  UPLOAD_DOCS_URL,
  UPDATE_ADDRESS_URL,
  GET_ACTIVE_GSTS,
  VERIFY_GSTIN_URL,
} from 'constants/url';
import { SOURCE_TYPE } from 'utils/constants';

// Types
import {
  FetchActiveGstsResponseData,
  IDocDetails,
  IGetRegDetails,
  IUpdateAddress,
  IUpsertDocDetails,
  IUpsertRegDetails,
  IVerifyGstin,
  MerchantDocsResponseData,
} from './types';

export async function getRegDetails<T>({ regKeys }: IGetRegDetails) {
  const { url, method } = regKeys
    ? GET_SELECTED_REG_DETAILS_URL
    : GET_REG_DETAILS_URL;
  const options = {
    method,
    body: regKeys ? JSON.stringify({ regKeys }) : undefined,
  };
  const response: T = await request(url, options);
  return response;
}

export async function getDocDetails({
  docKey,
}: IDocDetails): Promise<MerchantDocsResponseData> {
  const urlObject = docKey ? GET_MERCHANT_DOC_URL : GET_MERCHANT_DOCS_URL;
  let { url } = urlObject;
  const { method } = urlObject;
  if (docKey) {
    url += `?docType=${docKey}`;
  }
  const options = {
    method,
  };
  const response: MerchantDocsResponseData = await request(url, options);
  return response;
}

export async function getActiveGsts(): Promise<FetchActiveGstsResponseData> {
  const { url, method } = GET_ACTIVE_GSTS;
  const options = {
    method,
  };
  const response = await request(url, options);
  return response;
}

export async function verifyGstin({ data }: IVerifyGstin) {
  const { url, method } = VERIFY_GSTIN_URL;
  const options = {
    method,
    body: JSON.stringify({
      ...data,
      sourceType: SOURCE_TYPE.DASHBOARD,
    }),
    useBasePath: true,
  };
  return request(url, options);
}

export async function upsertRegDetails({
  data,
  fieldFormatMapper,
}: IUpsertRegDetails) {
  const formattedPayload = formatRequestBody({
    data,
    fieldFormatMapper,
  });
  const promiseArray = formattedPayload.map((payloadItem: any) => {
    const {
      url: { url, method },
      ...body
    } = payloadItem;
    const options = {
      method,
      body: JSON.stringify(body),
    };
    return request(url, options);
  });
  await Promise.all(promiseArray);
}

export async function updateAddress({ data }: IUpdateAddress) {
  const { url, method } = UPDATE_ADDRESS_URL;

  const options = {
    method,
    body: JSON.stringify(data),
    useBasePath: true,
  };
  await request(url, options);
}

export async function upsertDocDetails({
  data,
  fieldFormatMapper,
}: IUpsertDocDetails) {
  const formData = buildFormDataObject({
    data,
    fieldFormatMapper,
  });
  const { url, method } = UPLOAD_DOCS_URL;
  const options = {
    method,
    body: formData,
  };
  await request(url, options);
}
